import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FiExternalLink } from "react-icons/fi";
import { BiBookmark, BiBookmarkHeart } from "react-icons/bi";
import { AiOutlineClose } from "react-icons/ai";
import Header from "../components/headerfooter/Header";
import Footer from "../components/headerfooter/Footer";
import CallToAction from "../components/home/CallToAction";
import Breadcrumb from "../components/Breadcrumb";
import MobileFooter from "../components/MobileFooter";
import axios from "axios";
import { IMAGE_URL, REACT_APP_API_PORT, VIDEO_URL } from "../Api";
import ReactPlayer from "react-player";
import { getDecryptedData } from "../config/crypto";
import Loader from "../components/Loader";
import { motion, AnimatePresence } from "framer-motion";
import { toast } from "react-toastify";
import { PiSealCheckFill } from "react-icons/pi";
const JustLaunched = () => {
  const navigate = useNavigate()
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [limit, setLimit] = useState(8);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  const getData = async (page) => {
    try {
      setIsLoading(true);
      const user = getDecryptedData("user")
      let userId = ""
      if (user) {
        userId = user._id
      }
      const res = await axios.get(
        `${REACT_APP_API_PORT}user/homepage/all_new_launch_tool_list?limit=${limit}&page=${page}&userId=${userId}`
      );
      setIsLoading(false);
      if (res.data.status) {
        setData(res.data.data);
        setTotalPages(res.data.pagination?.totalPages);
        setTotalItems(res.data.pagination?.totalItems);
        if (selectedItem) {
          const matchedItem = res.data.data.find(item => item._id === selectedItem._id);
          if (matchedItem) {
            setSelectedItem(matchedItem);
          }
        }
      }
    } catch (err) {
      setIsLoading(false);
      console.log(err);
    }
  };

  useEffect(() => {
    getData(currentPage);
  }, [currentPage, limit]);

  const handleLoadMore = () => {
    setLimit((prevLimit) => prevLimit + 8);
  };

  const openSidebar = (item) => {
    setSelectedItem(item);
    setIsSidebarOpen(true);
  };

  const closeSidebar = () => {
    setIsSidebarOpen(false);
    setSelectedItem(null);
  };

  const [openFaq, setOpenFaq] = useState(null);

  const handleFaqToggle = (index) => {
    setOpenFaq((prev) => (prev === index ? null : index)); // Toggle the FAQ
  };

  const handleToolNavigate = async (toolId) => {
    const user = getDecryptedData("user");
    if (!user) {
      navigate(`/login`)
    }
    if (user) {
      try {
        setIsLoading(true)
        const token = getDecryptedData('token')
        const res = await axios.post(`${REACT_APP_API_PORT}user/frontend/save-tool`, {
          tool_id: toolId,
        }, {
          headers: {
            'Content-Type': 'application/json',
            'x-access-token': token
          }
        });
        setIsLoading(false)
        if (res.data.status) {
          getData()
        }
      }
      catch (err) {
        setIsLoading(false)
        if (err.response.data.status === false) {
          toast.error(err.response.data.message)
        }
      }
    }
  }

  function replaceSpacesWithHyphen(text) {
    return text.replace(/\s+/g, '-');
  }

  return (
    <>
      <Loader isLoading={isLoading} />
      {/* <TopBar /> */}
      <Header />
      <Breadcrumb
        title="Just Launched"
        breadcrumbs={[{ label: "Just Launched" }]}
        paragraph="Discover the Newest AI Tools Transforming Innovation."
      />

      <section className="bg-background-back1 overflow-hidden">
        <div className="container max-w-[80rem] mx-auto px-4 pt-5">
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
            {data?.slice(0, limit).map((item) => (
              <div
                key={item._id}
                className="blurBox bg-gray-900 rounded-xl overflow-hidden shadow-lg p-4 transition-transform duration-200 cursor-pointer"
              // onClick={() => openSidebar(item)}
              >
                <div className="flex items-center gap-2"
                  // onClick={() => openSidebar(item)}
                  onClick={() => {
                    if (item?.tool_name) {
                      navigate(`/tool-detail/${replaceSpacesWithHyphen(item?.tool_name)}/${item?._id}`)
                    }
                    else {
                      navigate(`/tool-detail/${item?._id}`)
                    }
                  }}
                >
                  <div className="relative">
                    <img
                      src={item.logo ? IMAGE_URL + item.logo + "?type=tool" : "/default.jpeg"}
                      // onError={(e)=>e.src.target='/default.jpeg'}
                      onError={(e) => {
                        e.target.onerror = null; // Prevents infinite loop if default image fails
                        e.target.src = '/default.jpeg';
                      }}
                      alt={`${item.tool_name} logo`}
                      className="h-12 w-12 rounded-full"
                    />
                    {
                      (item?.isVerified && item?.isVerified === "Yes") &&
                      <span className="absolute -top-1 -right-1 h-4 w-4 flex items-center justify-center">
                        <PiSealCheckFill className="text-primary h-4 w-4 bg-white rounded-full" />
                      </span>
                    }

                  </div>
                  <div className="flex flex-col truncate">
                    <h5 className="text-lg font-bold text-white truncate">
                      {item.tool_name.length > 20 ? `${item.tool_name.slice(0, 20)}...` : item.tool_name}
                    </h5>
                    <p className="text-sm text-gray-400 truncate">
                      {item?.main_category_id?.category_name}
                    </p>
                  </div>
                </div>
                <p className="text-sm text-gray-400 truncate">{item.description}</p>
                <img
                  // onClick={() => openSidebar(item)}
                  onClick={() => {
                    if (item?.tool_name) {
                      navigate(`/tool-detail/${replaceSpacesWithHyphen(item?.tool_name)}/${item?._id}`)
                    }
                    else {
                      navigate(`/tool-detail/${item?._id}`)
                    }
                  }}
                  src={item.image ? IMAGE_URL + item.image + "?type=tool" : "/just-launch-default.png"}
                  // onError={(e)=>e.src.target='/just-launch-default.png'}
                  onError={(e) => {
                    e.target.onerror = null; // Prevents infinite loop if default image fails
                    e.target.src = '/just-launch-default.png';
                  }}
                  alt={item.title}
                  className="w-full mt-3 rounded-lg object-cover h-40 lg:h-40"
                />
                <div className="flex justify-between items-center mt-2">
                  <span className="text-sm text-gray-400">{item.payment_type}</span>
                  <div className="flex flex-row">
              
                    <button type="button" onClick={() => handleToolNavigate(item?._id)}>
                      <AnimatePresence mode="wait">
                        {item?.is_saved ? (
                          <motion.div
                            key="saved"
                            initial={{ opacity: 0, scale: 0.5 }}
                            animate={{ opacity: 1, scale: 1 }}
                            exit={{ opacity: 0, scale: 0.5 }}
                            transition={{ duration: 0.3 }}
                          >
                            <BiBookmarkHeart className="w-5 h-5 text-primary hover:text-white" />
                          </motion.div>
                        ) : (
                          <motion.div
                            key="unsaved"
                            initial={{ opacity: 0, scale: 0.5 }}
                            animate={{ opacity: 1, scale: 1 }}
                            exit={{ opacity: 0, scale: 0.5 }}
                            transition={{ duration: 0.3 }}
                          >
                            <BiBookmark className="w-5 h-5 text-primary hover:text-white" />
                          </motion.div>
                        )}
                      </AnimatePresence>
                    </button>
                    {/* Visit Link Icon */}
                    <Link to={item?.visit_link} target="_blank" className="ml-2">
                      <FiExternalLink className="text-primary w-5 h-5" />
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {data.length < totalItems && (
            <div className="flex justify-center mt-6">
              <button
                onClick={handleLoadMore}
                className="border-2 border-customBlue px-4 py-2 rounded text-white hover:bg-background-primary transition text-[15px] font-bold uppercase"
              >
                Load More
              </button>
            </div>
          )}
        </div>
      </section>

      {isSidebarOpen && selectedItem && (
        <div className="fixed inset-0 flex items-center justify-end bg-black bg-opacity-70 z-50">
          <div className="bg-background-back2 p-6 rounded-l-lg w-3/4 max-w-lg h-full overflow-y-auto">
            <button className="absolute top-2 right-2 text-white" onClick={closeSidebar}>
              <AiOutlineClose size={20} />
            </button>
            {
              (selectedItem?.video === null && selectedItem?.youtube_link === null) && <>
                <img
                  className="w-full object-cover rounded-lg"
                  style={{ width: "100%", height: "300px" }}
                  src={selectedItem.image ? IMAGE_URL + selectedItem.image + "?type=tool" : "/favicon.png"}
                  alt={selectedItem.tool_name}
                />
              </>
            }

            {
              (selectedItem?.video_type === 'upload' && selectedItem?.video !== null && selectedItem?.video !== "") && <>
                <video style={{ width: "100%", height: "300px" }} controls>
                  <source src={VIDEO_URL + selectedItem?.video + "?type=tool"} type="video/mp4" />
                </video>
              </>
            }


            {
              selectedItem?.video_type === "link" && selectedItem?.youtube_link && <>
                <ReactPlayer url={selectedItem?.youtube_link} width="100%" height="300px" controls />
              </>
            }

            <h2 className="text-2xl font-bold text-white mt-4">{selectedItem.tool_name}</h2>
            <p className="text-sm text-gray-400 mt-1">{selectedItem?.main_category_id?.category_name}</p>
            <p className="text-gray-400 mt-2">{selectedItem.description}</p>
            <div
              className="text-sm lg:text-base xl:text-md font-medium text-gray-400 dark:text-white my-3"
              dangerouslySetInnerHTML={{ __html: selectedItem?.details }}
            />


            {/* Save and Visit Icons */}
            <div className="flex mt-6">
              {/* Save Icon */}
              {/* <Link to="">
                <BiBookmark className="w-6 h-6 text-white hover:text-yellow-400 cursor-pointer" />
              </Link> */}
              <button type="button" onClick={() => handleToolNavigate(selectedItem?._id)}>
                <AnimatePresence mode="wait">
                  {selectedItem?.is_saved ? (
                    <motion.div
                      key="saved"
                      initial={{ opacity: 0, scale: 0.5 }}
                      animate={{ opacity: 1, scale: 1 }}
                      exit={{ opacity: 0, scale: 0.5 }}
                      transition={{ duration: 0.3 }}
                    >
                      <BiBookmarkHeart className="w-5 h-5 text-green-500 hover:text-white" />
                    </motion.div>
                  ) : (
                    <motion.div
                      key="unsaved"
                      initial={{ opacity: 0, scale: 0.5 }}
                      animate={{ opacity: 1, scale: 1 }}
                      exit={{ opacity: 0, scale: 0.5 }}
                      transition={{ duration: 0.3 }}
                    >
                      <BiBookmark className="w-5 h-5 text-primary hover:text-white" />
                    </motion.div>
                  )}
                </AnimatePresence>
              </button>
              {/* Visit Link Icon */}
              <Link to={selectedItem?.visit_link} target="_blank" className="ml-4">
                <FiExternalLink className="w-6 h-6 text-white hover:text-yellow-400 cursor-pointer" />
              </Link>
            </div>

            {/* FAQ Section - Dynamic */}
            {
              (selectedItem?.faqs?.length > 0) && <>
                <div className="mt-6" id="Faq">
                  <h3 className="sm:text-base text-sm font-semibold text-white">Faq's</h3>
                  <div className="w-full bg-background-back1 rounded" data-orientation="vertical">
                    {
                      (selectedItem?.faqs?.length > 0) &&
                      selectedItem?.faqs?.map((item, index) => {
                        return <>
                          <div className="px-6 mt-2 rounded-xl bg-foreground">
                            <h3 className="flex">
                              <button
                                type="button"
                                onClick={() => handleFaqToggle(index)}
                                aria-expanded={openFaq === index ? "true" : "false"}
                                className="flex flex-1 items-center justify-between py-4 font-medium transition-all outline-none focus:outline-none border-none lg:text-base text-sm text-left text-white"
                              >
                                {item?.question}
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  strokeWidth="2"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  className={`lucide lucide-chevron-down h-4 w-4 shrink-0 transition-transform duration-200 ${openFaq === index ? "rotate-180" : ""}`}
                                >
                                  <path d="m6 9 6 6 6-6"></path>
                                </svg>
                              </button>
                            </h3>

                            <div
                              className={`overflow-hidden text-sm transition-all text-white ${openFaq === index ? "max-h-96" : "max-h-0"}`}
                              style={{
                                transition: "max-height 0.3s ease-out",
                              }}
                            >
                              <p className="mt-2">{item?.answer}</p>
                            </div>
                          </div>
                        </>
                      })
                    }



                  </div>
                </div>
              </>
            }
          </div>
        </div>
      )}

      <CallToAction />
      <Footer />
      <MobileFooter />
    </>
  );
};

export default JustLaunched;
